module.exports = __webpack_public_path__ + "img/arrow.39b289f5.svg";